export default function About() {
  return (
    <section id="about" className="py-12 px-6 bg-yellow-50">
      <h3 className="text-2xl font-bold text-center mb-4">About Us</h3>
      <p className="max-w-3xl mx-auto text-lg text-center">
        Odia Seva Foundation is dedicated to serving and protecting cows with love and care. 
        Currently, we provide shelter, food, and medical care for 20 cows. 
        Your support ensures their happiness and well-being.
      </p>
    </section>
  );
}
